import React from 'react'
import { Link } from 'gatsby'
import { useSelector } from 'react-redux'

import SimpleHero from '../hero/simpleHero'
import List from '../newsroom/list'
import Hub from '../newsroom/hub'
import SocialCard from '../cards/socialCard'
import EventCard from '../cards/eventCard'
import DocCard from '../cards/docCard'

import transformLink from '../../utils/transformLink'
import GetNewsroomUrls from '../../utils/getNewsroomUrls'

const NewsroomLayout = ({data, currentUrl, isFirstRun, events, news, socials, allNews, page = 1, documents, pressReleases, furtherContent = null, lang}) => {
  let type = data.type
  const storeLang = useSelector(state => state.lang)
  const newsroomUrls = GetNewsroomUrls()

  const renderSEOContent = (type) => {
    switch(type) {
      case 'Hub':
        return (
          <>
            {renderSectionPagination('Événements', events.length)}
            {renderSectionPagination('Actualités', allNews.length)}
            {renderSectionPagination('Publications', documents.length)}
            {renderSectionPagination('Communiqués de presse', pressReleases.length)}
          </>
        )
      case 'Événements':
        return (
          <>
            { events.slice((page - 1) * 12, page * 12).map((event, i) => {
              return (
                <EventCard event={event} key={i} />
              )
            })  }
            {renderSEOPagination(Math.ceil(events.length / 12))}
          </>
        )
      case 'Publications':
        return (
          <>
            { documents.slice((page - 1) * 12, page * 12).map((document, i) => {
              return (
                <DocCard document={document} key={i} />
              )
            })  }
            {renderSEOPagination(Math.ceil(documents.length / 12))}
          </>
        )
      case 'Communiqués de presse':
        return (
          <>
            { pressReleases.slice((page - 1) * 12, page * 12).map((pressRelease, i) => {
              return (
                <DocCard document={pressRelease} isPressRelease={true} key={i} />
              )
            }) }
            {renderSEOPagination(Math.ceil(pressReleases.length / 12))}
          </>
        )
      case 'Actualités':
        return (
          <>
            { allNews.slice((page - 1) * 12, page * 12).map((news, i) => {
              return (
                  <React.Fragment key={i}>
                    { news.title ?
                      <Link to={transformLink(news, false, false).url}>{news.title}</Link>
                    : <SocialCard social={news} seo={true} /> }
                  </React.Fragment>
              )
            })  }
            {renderSEOPagination(Math.ceil(allNews.length / 12))}
          </>
        )
      default:
        return ''
    }
  }

  const renderSEOPagination = (nbPages) => {
    return (
      <>
        { Array.from(Array(nbPages)).map((page, i) => {
          return (
            <Link key={i} to={`${currentUrl}${i > 0 ? `/page/${i + 1}` : ''}`}>{i + 1}</Link>
          )
        })}
      </>
    )
  }

  const renderSectionPagination = (sectionType, nbItems) => {
    const sectionUrl = newsroomUrls[sectionType]?.[storeLang]
    if (!sectionUrl) return null
    const nbPages = Math.ceil(nbItems / 12)
    return (
      <>
        {Array.from(Array(nbPages)).map((_, i) => {
          return (
            <Link key={`${sectionType}-${i}`} to={`/${sectionUrl}${i > 0 ? `/page/${i + 1}` : ''}`}>
              {sectionType} - {i + 1}
            </Link>
          )
        })}
      </>
    )
  }

  return (
    <>
      <SimpleHero 
        currentUrl={currentUrl}
        data={data} 
        type={type === 'Hub' ? null : 'newsroom'}
        subType={data.type} />

      { type !== 'Hub' ?
        (() => {
          let seoItems = []
          switch (type) {
            case 'Événements': seoItems = events; break
            case 'Publications': seoItems = documents; break
            case 'Communiqués de presse': seoItems = pressReleases; break
            case 'Actualités': seoItems = allNews; break
          }
          return (
            <List data={data} type={type} page={page} furtherContent={furtherContent} lang={lang} seoItems={seoItems} currentUrl={currentUrl} />
          )
        })()
        : <Hub
            pushPages={data.pushPages} 
            events={events.slice(0, 12)}
            news={news}
            socials={socials}
            documents={documents.slice(0, 12)}
            pressReleases={pressReleases.slice(0, 12)}
            furtherContent={furtherContent}
            lang={lang} />
      }

      { type === 'Hub' && isFirstRun &&
        <div className="sr-only" aria-hidden="true">{renderSEOContent(type)}</div>
      }
    </>
  )
}

export default NewsroomLayout